import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: '<router-outlet></router-outlet>'
})
export class InternationalizationComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private app: AppService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {

      let languageCodeUrl: any = this.route.snapshot.paramMap.get('languageCode')
      let languageCodeStorage = localStorage.Language ? localStorage.Language : 'ar'

      if (languageCodeUrl == 'en' || languageCodeUrl == 'ar') {
        // Now APP COMPONENT HANDLE THIS BLOCK CODE ******************

        // this.app.languageCode = languageCodeUrl
        // this.translate.use(languageCodeUrl);
        // localStorage.setItem("Language", languageCodeUrl);
        // this.setLangAll(languageCodeUrl);
        // this.setLangAll(languageCodeUrl);
      } else {

        // And this block of code won't happen cause now InternationalizationComponent have a Guard(LanguageGuard.ts), check it.

        // Direction
        // if (languageCodeStorage == 'ar') {
        //   localStorage.setItem("Direction", 'rtl');
        //   document.dir = 'rtl'
        // } else {
        //   localStorage.setItem("Direction", 'ltr');
        //   document.dir = 'ltr'
        // }
        // Direction

        // window.location.href = '/404';
        // this.router.navigate(['/404']);
        // return

        this.app.languageCode = languageCodeStorage
        this.translate.use(languageCodeStorage);
        localStorage.setItem("Language", languageCodeStorage);
        this.router.navigateByUrl(this.router.url.replace(languageCodeUrl, languageCodeStorage));
        this.setLangAll(languageCodeStorage);
        this.setLangAll(languageCodeStorage);
      }
    }

    // if (languageCodeUrl != ('en' || 'ar')) {
    //   this.router.navigateByUrl(this.router.url.replace(languageCodeUrl, languageCodeStorage));
    //   languageCodeUrl = languageCodeStorage
    // }

    // if (languageCodeUrl != languageCodeStorage) {
    //   localStorage.setItem("Language", languageCodeUrl);
    //   if (languageCodeUrl == 'en') {
    //     localStorage.setItem("Direction", 'ltr');
    //   } else if (languageCodeUrl == 'ar') {
    //     localStorage.setItem("Direction", 'rtl');
    //   }
    //   window.location.reload();
    // }
  }

  ngOnInit(): void {
  }


  setLangAll(lang) {
    setTimeout(() => {
      if (lang == 'en') {
        localStorage.setItem("Direction", 'ltr');
        document.dir = 'ltr'
      } else {
        localStorage.setItem("Direction", 'rtl');
        document.dir = 'rtl'
      }
    }, 300);
  }

}
